import { css } from 'lit';

export const style = css`
  @media (min-width: 744px) {
    .checkout-email-edit {
      display: flex;
    }

    fs-text-field {
      width: 50%;
    }

    .email {
      margin-right: 1rem;
    }

    .disclosure {
      text-align: center;
    }
  }

  fs-text-field {
    margin-bottom: 1rem;
  }

  .disclosure {
    background-color: #f4f4f4;
    font-size: 14px;
    line-height: 21px;
    padding: 0.5rem;
  }
`;
